import { Facepile } from "@dropbox/dig-components/avatar";
import { Truncate } from "@dropbox/dig-components/truncate";
import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import * as React from "react";
import styles from "./attendee.module.css";
import type { CalendarEventLabels } from "./types";

export interface AttendeeProps {
  attendees: Array<{
    id: string;
    name: string;
    email: string;
    profileImageUrl?: string;
  }>;
  labels: Pick<CalendarEventLabels, "getNumAttendeesLabel">;
  maxAvatars?: number;
  isSubtleLabel?: boolean;
  isLargeText?: boolean;
}

export const Attendee = ({
  attendees,
  labels,
  maxAvatars = 3,
  isSubtleLabel = false,
  isLargeText = false,
}: AttendeeProps) => {
  const attendeeCount = attendees.length;

  if (attendeeCount === 0) {
    return null;
  }

  return (
    <Box marginLeft="Micro Small" display="flex" alignItems="center">
      <Facepile size="xsmall" isInteractive={false}>
        {attendees.slice(0, maxAvatars).map((attendee) => (
          <Facepile.Item
            key={attendee.id}
            alt={`Avatar for ${attendee.name}`}
            src={attendee.profileImageUrl}
          >
            {!attendee.profileImageUrl &&
              attendee.name
                .split(" ")
                .map((part) => part[0])
                .join("")
                .substring(0, 2)}
          </Facepile.Item>
        ))}
      </Facepile>
      <Text
        size={isLargeText ? "large" : "medium"}
        color={isSubtleLabel ? "subtle" : "standard"}
        className={styles.attendeesText}
      >
        <Truncate
          tooltipControlProps={{
            auto: true,
            placement: "top",
          }}
        >
          {labels.getNumAttendeesLabel(attendeeCount)}
        </Truncate>
      </Text>
    </Box>
  );
};
